import "./index.css";
import class67Image from "../../assets/cousesAssets/class6_7.svg";
import class89Image from "../../assets/cousesAssets/class8_9.svg";
import class10Image from "../../assets/cousesAssets/class10.svg";

import experience from "../../assets/cousesAssets/Experience.svg";
import comprehensive from "../../assets/cousesAssets/Comprehensive.svg";
import smallBatch from "../../assets/cousesAssets/SmallBatch.svg";
import regular from "../../assets/cousesAssets/RegularFaculty.svg";
import meeting from "../../assets/cousesAssets/Meeting.svg";
import provenResult from "../../assets/cousesAssets/ProvenResult.svg";

const Classes = () => {
  return (
    <>
      <div id="courses" style={{ margin: "0" }}>
        {/* ---- CLASSES SECTION ---- */}
        <section className="classes-section">
          <div className="class-tabs">
            <span className="tab">Class 6 & 7</span>
            <span className="tab">Class 8 & 9</span>
            <span className="tab">Class 10</span>
          </div>

          <div className="class-cards">
            <div className="class-card">
              <img src={class67Image} alt="Class 6 & 7" className="class-img" />
              <div className="class-content">
                <h3>Classes 6 & 7</h3>
                <p>
                  Foundation building with focus on language skills, basic
                  mathematics, and environmental awareness
                </p>
                <div className="subjects">
                  <span>English</span>
                  <span>Mathematics</span>
                  <span>Science</span>
                </div>
                <a href="#details" className="view-details">
                  View Details →
                </a>
              </div>
            </div>

            <div className="class-card">
              <img src={class89Image} alt="Class 8 & 9" className="class-img" />
              <div className="class-content">
                <h3>Classes 8 & 9</h3>
                <p>
                  Foundation building with focus on language skills, basic
                  mathematics, and environmental awareness
                </p>
                <div className="subjects">
                  <span>English</span>
                  <span>Mathematics</span>
                  <span>Science</span>
                  <span>Social Studies</span>
                </div>
                <a href="#mnvf" className="view-details">
                  View Details →
                </a>
              </div>
            </div>

            <div className="class-card">
              <img src={class10Image} alt="Class 10" className="class-img" />
              <div className="class-content">
                <h3>Classes 10</h3>
                <p>
                  Foundation building with focus on language skills, basic
                  mathematics, and environmental awareness
                </p>
                <div className="subjects">
                  <span>Science</span>
                  <span>Mathematics</span>
                </div>
                <a href="#details" className="view-details">
                  View Details →
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ---- WHY CHOOSE SECTION ---- */}
        <section className="why-choose-section">
          <h2 className="title">Why Choose Saraswati Pathashala</h2>
          <p className="subtitle">
            Our commitment to educational excellence and student success sets us
            apart from other tuition centers
          </p>

          <div className="choose-cards">
            <div className="choose-card">
              <img
                src={experience}
                alt="Experienced Faculty"
                className="choose-icon"
              />
              <h3>Experienced Faculty</h3>
              <p>
                Our teaching have 10+ years of teaching experience with
                expertise in their respective subjects.
              </p>
            </div>

            <div className="choose-card">
              <img
                src={comprehensive}
                alt="Comprehensive Study Material"
                className="choose-icon"
              />
              <h3>Comprehensive Study Material</h3>
              <p>
                Well-structured study materials, practice papers, and revision
                notes tailored to each class and board.
              </p>
            </div>

            <div className="choose-card">
              <img
                src={smallBatch}
                alt="Small Batch Sizes"
                className="choose-icon"
              />
              <h3>Small Batch Sizes</h3>
              <p>
                Limited students per batch ensuring personalized attention and
                better interaction with teachers.
              </p>
            </div>

            <div className="choose-card">
              <img
                src={regular}
                alt="Regular Assessments"
                className="choose-icon"
              />
              <h3>Regular Assessments</h3>
              <p>
                Weekly tests and monthly assessments to track progress and
                identify improvement areas.
              </p>
            </div>

            <div className="choose-card">
              <img
                src={meeting}
                alt="Parent-Teacher Meeting"
                className="choose-icon"
              />
              <h3>Parent-Teacher Meeting</h3>
              <p>
                Regular feedback sessions with parents to discuss student
                progress and collaborative improvement plans.
              </p>
            </div>

            <div className="choose-card">
              <img
                src={provenResult}
                alt="Proven Results"
                className="choose-icon"
              />
              <h3>Proven Results</h3>
              <p>
                Consistent record of students achieving excellent results in
                board examinations and competitive tests.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Classes;
